module.exports = __webpack_public_path__ + "media/images/other.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/media/images/other.png
 ** module id = 35
 ** module chunks = 0
 **/